import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LogOut } from "lucide-react";
import { AdminLogin, CelebrationsManager, TOKEN_KEY } from "@/pages/CelebrationsAdmin";
import { EventsManager } from "@/pages/EventsAdmin";
import { JournalManager } from "@/pages/JournalAdmin";

const TABS = [
  { id: "events", label: "Events" },
  { id: "journal", label: "Field Journal" },
  { id: "celebrations", label: "Celebrations" },
];

export default function AdminPage() {
  const [token, setToken] = useState(() => sessionStorage.getItem(TOKEN_KEY));
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "events";

  const logout = useCallback(() => { sessionStorage.removeItem(TOKEN_KEY); setToken(null); }, []);

  return (
    <div className="section bg-[#f8f5ee] min-h-[70vh]" data-testid="admin-page">
      <div className="container-edge">
        {!token ? <AdminLogin onLogin={setToken} /> : (
          <>
            <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
              <div>
                <p className="overline">Team only</p>
                <h1 className="mt-2 text-4xl text-[#1e4d5d]" style={{ fontFamily: "Playfair Display, serif" }}>Team Admin</h1>
              </div>
              <button onClick={logout} className="text-sm text-[#2c5865] flex items-center gap-2 hover:text-[#d4a373]" data-testid="admin-logout">
                <LogOut size={14} /> Log out
              </button>
            </div>
            <div className="flex gap-1 sm:gap-2 border-b border-[#E5E1DA] mb-10 overflow-x-auto" role="tablist">
              {TABS.map((t) => (
                <button
                  key={t.id}
                  role="tab"
                  aria-selected={tab === t.id}
                  onClick={() => setParams({ tab: t.id })}
                  className={`px-3 sm:px-5 py-3 text-sm whitespace-nowrap tracking-wide -mb-px border-b-2 transition-colors ${tab === t.id ? "border-[#d4a373] text-[#1e4d5d] font-medium" : "border-transparent text-[#2c5865]/70 hover:text-[#1e4d5d]"}`}
                  data-testid={`admin-tab-${t.id}`}
                >
                  {t.label}
                </button>
              ))}
            </div>
            {tab === "events" && <EventsManager token={token} onUnauthorized={logout} />}
            {tab === "journal" && <JournalManager token={token} onUnauthorized={logout} />}
            {tab === "celebrations" && <CelebrationsManager token={token} onUnauthorized={logout} />}
          </>
        )}
      </div>
    </div>
  );
}
